import ActiveRecord from './active_record/base'

export class Role extends ActiveRecord {
	static tableName = 'roles'
	static defaultJoins = ['environments']
}
